"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'and-options',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        players: {
            type: Array,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    data() {
        return {
            responded: this.playerinput.options.map(() => undefined),
        };
    },
    methods: {
        playerFactorySaved(idx) {
            return (out) => {
                this.responded[idx] = out;
            };
        },
        canSave() {
            const refs = this.$refs.childInputs;
            if (!refs)
                return true;
            for (const child of refs) {
                if (child.canSave instanceof Function) {
                    if (child.canSave() === false) {
                        return false;
                    }
                }
            }
            return true;
        },
        saveData() {
            if (this.canSave() === false) {
                alert('Not all options selected');
                return;
            }
            const refs = this.$refs.childInputs;
            if (refs) {
                for (const child of refs) {
                    if (child.saveData instanceof Function) {
                        child.saveData();
                    }
                }
            }
            this.onsave({
                type: 'and',
                responses: this.responded,
            });
        },
    },
});
